import { createContext, useCallback, useContext, useState } from 'react'
import type { ReactNode } from 'react'

import { FilePreview } from './FilePreview'

import type { FilePreviewProps } from './types'

const FilePreviewSessionContext = createContext<((auth: FilePreviewProps) => void) | null>(null)

export function FilePreviewSessionProvider({ children }: { children: ReactNode }) {
    const [session, setSession] = useState<{ auth: FilePreviewProps; opening: number } | null>(null)
    const openFilePreview = useCallback((auth: FilePreviewProps) => {
        setSession((previous) => ({ auth, opening: (previous?.opening ?? 0) + 1 }))
    }, [])

    return (
        <FilePreviewSessionContext.Provider value={openFilePreview}>
            {children}
            {session && <FilePreview key={session.opening} {...session.auth} />}
        </FilePreviewSessionContext.Provider>
    )
}

export function useFilePreviewSession() {
    const openFilePreview = useContext(FilePreviewSessionContext)
    if (!openFilePreview) throw new Error('useFilePreviewSession must be used within FilePreviewSessionProvider')
    return { openFilePreview }
}
